import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlaneUp } from '@fortawesome/free-solid-svg-icons';
import { useOffline } from '../../offline/OfflineContext';
import './OfflineNavItem.css';

/**
 * Navbar entry for offline access.
 *
 * Renders as a plain <li> matching the surrounding nav items so it inherits
 * HMSNavbar's collapse behaviour without needing changes there. Hidden
 * entirely when the browser cannot support a pack, rather than showing a
 * control that can only disappoint.
 */
const OfflineNavItem = ({ collapsed, onNavigate }) => {
  const { supported, packLive, offline, openPanel } = useOffline();

  if (!supported) return null;

  const title = offline
    ? 'Offline — showing your saved snapshot'
    : packLive
    ? 'Offline pack ready'
    : 'Make IMT available offline';

  return (
    <li className="hms-offline-nav-item">
      <button
        type="button"
        className={`hms-offline-nav-btn ${offline ? 'is-offline' : ''} ${packLive ? 'is-ready' : ''}`}
        onClick={() => {
          if (onNavigate) onNavigate();
          openPanel();
        }}
        title={title}
      >
        <span className="hms-offline-nav-icon-wrap">
          <FontAwesomeIcon icon={faPlaneUp} className="hms-nav-icon" />
          {packLive && <span className="hms-offline-nav-dot" aria-hidden="true" />}
        </span>
        {!collapsed && <span>Offline access</span>}
      </button>
    </li>
  );
};

export default OfflineNavItem;
